export const zhCnLocale = {
  model: {
    application: '应用管理'
  },
  application: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    desc: '描述',
    shareDesc: '分享描述',
    shareTitle: '分享标题',
    wechatApplicationId: 'Wechat application',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: '分享图片',
    logo: 'Logo',
    creator: 'Creator',
    posterImage: '海报图片',
  }
}

export const enLocale = {
  model: {
    application: 'Application'
  },
  application: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    desc: 'Desc',
    shareDesc: 'Share description',
    shareTitle: 'Share title',
    wechatApplicationId: 'Wechat application',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: 'Share image',
    logo: 'Logo',
    creator: 'Creator',
    posterImage: 'Poster image',
  }
}

